import React, { memo, Fragment } from 'react';
import { string, func, shape, arrayOf } from 'prop-types';

import ActiveFilter from './ActiveFilter';

const ActiveFilters = ({
    activeFilters,
    clearFiltersButtonTitle,
    clearFilterTitle,
    handleClearFilters,
    onCheckboxChange
}) => {
    const renderActiveFilterByType = activeFilter => {
        switch (activeFilter.type) {
            case 'checkbox':
                return (
                    <Fragment key={activeFilter.id}>
                        {!!activeFilter.options &&
                            !!activeFilter.options.length &&
                            activeFilter.options.map(option => {
                                // if only some of subOptions is checked
                                if (!option.checked) {
                                    return option.subOptions.map(subOption => (
                                        <ActiveFilter
                                            clearFilterTitle={clearFilterTitle}
                                            key={subOption.id}
                                            onClearClick={() =>
                                                onCheckboxChange(
                                                    subOption.id,
                                                    activeFilter.id
                                                )
                                            }
                                            title={subOption.label}
                                        />
                                    ));
                                }

                                return (
                                    <Fragment key={option.id}>
                                        <ActiveFilter
                                            clearFilterTitle={clearFilterTitle}
                                            onClearClick={() =>
                                                onCheckboxChange(
                                                    option.id,
                                                    activeFilter.id
                                                )
                                            }
                                            title={option.label}
                                        />
                                        {!!option.subOptions &&
                                            !!option.subOptions.length &&
                                            option.subOptions.map(subOption => (
                                                <ActiveFilter
                                                    clearFilterTitle={
                                                        clearFilterTitle
                                                    }
                                                    key={subOption.id}
                                                    onClearClick={() =>
                                                        onCheckboxChange(
                                                            subOption.id,
                                                            activeFilter.id
                                                        )
                                                    }
                                                    title={subOption.label}
                                                />
                                            ))}
                                    </Fragment>
                                );
                            })}
                    </Fragment>
                );

            default:
                return null;
        }
    };

    if (!activeFilters || !activeFilters.length) {
        return null;
    }

    return (
        <div className="listing-active-filters">
            {clearFiltersButtonTitle && handleClearFilters && (
                <div className="listing-active-filters__clear-filters">
                    <button
                        className="link link--no-arrow"
                        onClick={handleClearFilters}
                        type="button"
                    >
                        {clearFiltersButtonTitle}
                    </button>
                </div>
            )}
            <div className="listing-active-filters__filters">
                <div className="listing-active-filters__row">
                    {activeFilters.map(renderActiveFilterByType)}
                </div>
            </div>
        </div>
    );
};

ActiveFilters.propTypes = {
    activeFilters: arrayOf(shape({})).isRequired,
    clearFiltersButtonTitle: string,
    clearFilterTitle: string.isRequired,
    handleClearFilters: func,
    onCheckboxChange: func.isRequired
};

export default memo(ActiveFilters);
